import { useRef, useEffect } from 'react';
import isDeepEqual from 'fast-deep-equal';

function useMemoCompare(obj) {
  var cmp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isDeepEqual;
  var holder = useRef(obj);
  var prev = holder.current;
  var stableObj = cmp(obj, prev) ? prev : obj;
  useEffect(function () {
    holder.current = stableObj;
  });
  return stableObj;
}

export default useMemoCompare;
